import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICalendarEventResource } from "../types";

export interface ICalendarEventDeleteMutationParameters {
    calendarEvent: RelationalValue<ICalendarEventResource>;
}

export type ICalendarEventDeleteMutationResult = void;

export const calendarEventDeleteMutation: IApiMutationFunction<ICalendarEventDeleteMutationParameters> = ({
    calendarEvent,
}) => {
    return {
        method: "DELETE",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}`,
    };
};

export const useCalendarEventDeleteMutation = createApiMutationHook<
    ICalendarEventDeleteMutationParameters,
    ICalendarEventDeleteMutationResult
>(calendarEventDeleteMutation);
